import React from 'react';

export default function Contact() {
  return (
    <div className="container">
      <h1>Contact</h1>
      <div className="table-wrapper" style={{ padding: 16 }}>
        <p>Have questions or suggestions? Reach out:</p>
        <ul>
          <li>Email: contact@example.com</li>
          <li>Discord: yourserver#1234</li>
        </ul>
      </div>
    </div>
  );
}
